export const SHELL_SET_SETTINGS = 'SHELL/SET_SETTINGS'
export const SET_SUBMENU = 'SHELL/SET_SUBMENU'
export const CLEAR_SUBMENU = 'SHELL/CLEAR_SUBMENU'
export const SET_ROUTE_TITLE = 'SHELL/SET_ROUTE_TITLE'
export const REMOVE_ROUTE_TITLE = 'SHELL/REMOVE_ROUTE_TITLE'
export const STICKY_FOOTER_MOUNTED = 'SHELL/STICKY_FOOTER_MOUNTED'
export const STICKY_FOOTER_UNMOUNTED = 'SHELL/STICKY_FOOTER_UNMOUNTED'
export const HIDE_SUBMENU = 'SHELL/HIDE_SUBMENU'
export const SHOW_SUBMENU = 'SHELL/SHOW_SUBMENU'
